var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'spinner-container',
  'd-flex',
  'align-items-center',
  'justify-content-center',
  _vm.disables ? 'disabled' : '' ]},[(_vm.useCircleSpinner)?_c('div',{staticClass:"loader",style:({'font-size': ((_vm.size / 8) + "px")})}):_c('div',[_c('bulb-spinner',{attrs:{"size":_vm.size}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }